import type { CourseHole, HoleRange } from '@/lib/db/types';

/** Par for the holes actually played (9-hole rounds use half-course or hole sum). */
export function playedPar(
  holes: HoleRange,
  coursePar: number,
  courseHoles?: CourseHole[],
): number {
  if (courseHoles?.length) {
    const sorted = [...courseHoles].sort((a, b) => a.hole_num - b.hole_num);
    const slice =
      holes === 'front-9' ? sorted.slice(0, 9)
        : holes === 'back-9' ? sorted.slice(9, 18)
          : sorted.slice(0, 18);
    if (slice.length) return slice.reduce((s, h) => s + h.par, 0);
  }
  if (holes === 'front-9' || holes === 'back-9') return Math.round(coursePar / 2);
  return coursePar;
}

export function holesLabel(holes: HoleRange): string {
  if (holes === 'front-9') return 'Front 9 · 9 holes';
  if (holes === 'back-9') return 'Back 9 · 9 holes';
  return '18 holes';
}

export function scoreToParLabel(score: number, par: number): string {
  const d = score - par;
  if (d === 0) return 'E';
  return d > 0 ? `+${d}` : `${d}`;
}
